import { Control, FieldErrors } from 'react-hook-form';

import { ContentCard } from 'apps/dashboard/shared/scripts/components';
import { DeliveryMethod } from 'apps/shared/scripts/__generated__/graphql.generated';
import { Divider, RadioOption } from 'apps/shared/scripts/components';

import { FORM_FIELDS } from '../constants';
import { FormValues } from '../types';

import EmailPreference from './EmailPreference';
import ManualPreference from './ManualPreference';

interface Props {
  control: Control<FormValues>;
  errors: FieldErrors<FormValues>;
  preference: string;
}

const CardDeliveryPreference = ({ control, errors, preference }: Props) => {
  return (
    <>
      <ContentCard noPadding>
        <RadioOption
          control={control}
          name={FORM_FIELDS.DELIVERY_METHOD.name}
          title={'Manual'}
          subtitle={
            'Mark the card as published and share a link to the card with the recipient.'
          }
          option={DeliveryMethod.Manual}
        />
        <Divider />
        <RadioOption
          control={control}
          name={FORM_FIELDS.DELIVERY_METHOD.name}
          title={'Email'}
          subtitle={'Have Cardjoy send the card to the recipient via e-mail.'}
          option={DeliveryMethod.Email}
        />
      </ContentCard>
      {preference === DeliveryMethod.Email && (
        <EmailPreference control={control} errors={errors} />
      )}
      {preference === DeliveryMethod.Manual && <ManualPreference />}
    </>
  );
};

CardDeliveryPreference.displayName = 'CardDeliveryPreference';

export default CardDeliveryPreference;
